import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import API from '../lib/api';

const AuthCallback = () => {
  const { refresh } = useAuth();
  const nav = useNavigate();
  // useRef (not useState) prevents double-exchange under React 18 StrictMode.
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      // Emergent auth delivers session_id in URL fragment: #session_id=xxxxx
      const hash = window.location.hash || '';
      const m = hash.match(/session_id=([^&]+)/);
      if (m) {
        try {
          await API.post('/auth/emergent/exchange', {}, {
            headers: { 'X-Session-ID': decodeURIComponent(m[1]) },
          });
          // scrub fragment so refresh doesn't re-exchange
          window.history.replaceState(null, '', window.location.pathname);
        } catch (e) {
          toast.error(e.response?.data?.detail || 'Google sign-in failed');
        }
      }
      const u = await refresh();
      const dest = u?.role === 'admin' ? '/admin' : u?.role === 'partner' ? '/partner' : '/';
      nav(dest, { replace: true });
    })();
  }, [refresh, nav]);

  return (
    <div className="p-10 text-center">
      <div className="font-display text-[22px]">Signing you in…</div>
      <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mt-2">Please wait</div>
    </div>
  );
};

export default AuthCallback;
